module.exports = __webpack_public_path__ + "static/media/icn_all_expenses_covid_myway.b4148546.svg";